import { api } from "../Configurations/axios";


export const GetPleaScheduleByPleaId = async (pleaId: string) => {
    try {
        const result = await api.get(`/PleaSchedule/GetPleaScheduleByPleaId?pleaId=${pleaId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export const CreatePleaSchedule = async (name: string, details: string, physicalIndicator: string, startDate: Date, endDate: Date, startMonth: number, duration: number, finepDuration: number, pleaId: string) => {
    try {
        var result = await api.post('/PleaSchedule/Create', 
            {
                name: name,
                details: details,
                physicalIndicator: physicalIndicator,
                startDate: startDate,
                endDate: endDate,
                startMonth: startMonth,
                duration: duration,
                finepDuration: finepDuration,
                pleaId: pleaId
            });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export const EditPleaSchedule = async ( id: string, name: string, details: string, physicalIndicator: string, startDate: Date, endDate: Date, startMonth: number, duration: number, finepDuration: number, pleaId: string) => {
    try {
        var result = await api.put('/PleaSchedule/Edit', 
            {
                id: id,
                name: name,
                details: details,
                physicalIndicator: physicalIndicator,
                startDate: startDate,
                endDate: endDate,
                startMonth: startMonth,
                duration: duration,
                finepDuration: finepDuration,
                pleaId: pleaId
            });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export const DeletePleaScheduleById = async (scheduleId: string) => {
    try {
        const result = await api.delete(`/PleaSchedule/Delete`, { data: { pleaScheduleId: scheduleId} });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export const DownloadPleaScheduleByPleaId = async ( pleaId: string) => {
    try {

        const result = await api.get(`PleaSchedule/DownloadSchedule?pleaId=${pleaId}`, {
            responseType: 'blob'
        });
        const response = await result.data;
        return response;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}